/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { publicBookingShow } from '../../axios/publicBookingShow'
import type {
	PublicBookingShowError,
	PublicBookingShowPathParams,
	PublicBookingShowResponse,
} from '../../types/PublicBookingShow'

export const publicBookingShowQueryKey = (tokenString: PublicBookingShowPathParams['tokenString']) =>
	[{ url: '/interview-scheduling/booking/:tokenString', params: { tokenString } }] as const

export type PublicBookingShowQueryKey = ReturnType<typeof publicBookingShowQueryKey>

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/PublicBookingController.php PublicBookingController::show */
export function publicBookingShowQueryOptions(
	tokenString: PublicBookingShowPathParams['tokenString'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		PublicBookingShowResponse,
		AxiosError<PublicBookingShowError>,
		PublicBookingShowResponse,
		PublicBookingShowQueryKey
	>({
		queryKey: publicBookingShowQueryKey(tokenString),
		queryFn: ({ signal }) => publicBookingShow(tokenString, { signal, ...config }).then(res => res.data),
		enabled: !!tokenString,
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/PublicBookingController.php PublicBookingController::show */
export function usePublicBookingShow<TSelectData = PublicBookingShowResponse>(
	tokenString: PublicBookingShowPathParams['tokenString'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					PublicBookingShowResponse,
					AxiosError<PublicBookingShowError>,
					TSelectData,
					PublicBookingShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<PublicBookingShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...publicBookingShowQueryOptions(tokenString),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/PublicBookingController.php PublicBookingController::show */
export function usePublicBookingShowSuspense<TSelectData = PublicBookingShowResponse>(
	tokenString: PublicBookingShowPathParams['tokenString'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					PublicBookingShowResponse,
					AxiosError<PublicBookingShowError>,
					TSelectData,
					PublicBookingShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<PublicBookingShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...publicBookingShowQueryOptions(tokenString),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
